import { Script } from 'playcanvas'

/**
 * Base GSplat shader effect used by the entrance animation. This is the
 * material lifecycle from 3dgs_web, trimmed to the playback features needed
 * by this viewer.
 */
export class GsplatShaderEffect extends Script {
  static scriptName = 'gsplatShaderEffect'

  effectTime = 0
  elapsedTime = 0
  manualEffectTimeEnabled = false
  manualEffectTime = 0
  material = null

  initialize() {
    this.effectTime = 0
    this.elapsedTime = 0
    this.material = null
    this.on('enable', () => {
      this.effectTime = 0
      this.elapsedTime = 0
      this.applyShaders()
    })
    this.on('disable', () => this.removeShaders())
    this.on('destroy', () => this.removeShaders())
    this.applyShaders()
  }

  applyShaders() {
    const apply = () => {
      this.material = this.entity.gsplat?.unified
        ? this.app.scene.gsplat?.material ?? null
        : this.entity.gsplat?.material ?? null
      if (this.material) this.applyShaderToMaterial(this.material)
    }

    if (this.entity.gsplat?.material || this.entity.gsplat?.unified) {
      apply()
    } else {
      this.entity.gsplat?.once?.('load', apply)
    }
  }

  removeShaders() {
    if (!this.material) return
    const shaderLanguage = this.app.graphicsDevice?.isWebGPU ? 'wgsl' : 'glsl'
    this.material.getShaderChunks(shaderLanguage).delete('gsplatModifyVS')
    this.material.update()
    this.material = null
  }

  applyShaderToMaterial(material) {
    const shaderLanguage = this.app.graphicsDevice?.isWebGPU ? 'wgsl' : 'glsl'
    const shader = shaderLanguage === 'wgsl' ? this.getShaderWGSL() : this.getShaderGLSL()
    material.getShaderChunks(shaderLanguage).set('gsplatModifyVS', shader)
    material.update()
  }

  update(dt) {
    if (!this.material) this.applyShaders()
    if (!this.material) return
    if (this.manualEffectTimeEnabled) {
      this.effectTime = Math.max(0, Number(this.manualEffectTime) || 0)
    } else {
      this.elapsedTime += Math.max(0, Number(dt) || 0)
      this.effectTime = this.elapsedTime
    }
    this.updateEffect(this.effectTime, dt)
    this.material?.update()
  }

  shouldStopEffect() {
    return typeof this.isEffectComplete === 'function' && this.isEffectComplete()
  }

  setUniform(name, value) {
    this.material?.setParameter(name, value)
  }

  getShaderGLSL() {
    throw new Error(`${this.constructor.name} must implement getShaderGLSL()`)
  }

  getShaderWGSL() {
    throw new Error(`${this.constructor.name} must implement getShaderWGSL()`)
  }

  updateEffect() {}
}
